import { render } from "./Vessels.vue?vue&type=template&id=5bd51165"
import script from "./Vessels.vue?vue&type=script&lang=js"
export * from "./Vessels.vue?vue&type=script&lang=js"
script.render = render

export default script